<template>
  <div class="table-wrap" id="table-print">
    <table id="tableA">
      <tr v-for="(item, row) in table_data" :key="row">
        <td v-for="(content, col) in item" :id="'tb__' + row + '_' + col" :key="col">{{ content }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      table_data: []
    }
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    uniTable(tableId, colLength) {
      var tb = document.getElementById(tableId)
      var i = 0;
      var j = 0;
      var rowCount = tb.rows.length; //   行数
      var colCount = tb.rows[0].cells.length; //   列数
      var obj1 = null;
      var obj2 = null;
      for (i = 0; i < colCount; i++) {
        if (i == colLength) break;
        obj1 = document.getElementById("tb__0_" + i)
        for (j = 1; j < rowCount; j++) {
          obj2 = document.getElementById("tb__" + j + "_" + i);
          if (obj1.innerText == obj2.innerText && (obj1.innerText != '' || obj2.innerText != '')) {
            obj1.rowSpan++;
            obj2.parentNode.removeChild(obj2);
          } else {
            obj1 = document.getElementById("tb__" + j + "_" + i);
          }
        }
      }
    },
    getTableData() {
      let $this = this;
      let array = []
      let category = localStorage.getItem('category');
      let categoryIds = localStorage.getItem('categoryIds');
      let dateType = localStorage.getItem('dateType');
      let startData = localStorage.getItem('startData');
      let endData = localStorage.getItem('endData');
      array = [category, categoryIds, dateType, startData, endData]
      //   localStorage.clear();
      this.$get('customerelectricityreport/getbuserelecreportdata', array
      ).then((response) => {
        this.table_data = response.tableData;
        this.table_data.unshift(response.columnList);
        setTimeout(function () {
          $this.uniTable('tableA', 2);
        }, 50)
        setTimeout(function () {
          this.print()
        }, 500)
      })

    },
    print() {
      window.print()
    }
  }

}
</script>
<style lang="scss">
.table-wrap {
  padding: 10px;
  height: 650px;
  overflow-x: auto;
  max-width: 1380px;
  margin: 0 auto;
  table {
    width: 1000px;
    // height: 520px;
    border: #1384c5 1px solid;
    border-collapse: collapse;
    color: #fff;
    overflow-x: hidden;
    table-layout: fixed;
    word-break: break-all;
    word-wrap: break-word;

    tr {
      td {
        border: #1384c5 1px solid;
        width: 80px;
        height: 36px;
        text-align: center;
      }

      &:first-child {
        height: 50px;
        background-color: #409eff;
      }
    }
  }
}
</style>
